import { createEvent, listVisibleEvents, updateEvent } from "../../services/db";

function cacheKeyForUser(uid) {
  return `kalendario.events.${uid}`;
}

function readCachedEvents(uid) {
  if (!uid) return [];
  try {
    const raw = localStorage.getItem(cacheKeyForUser(uid));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_err) {
    return [];
  }
}

function writeCachedEvents(uid, items) {
  if (!uid) return;
  try {
    localStorage.setItem(cacheKeyForUser(uid), JSON.stringify(items || []));
  } catch (_err) {
    // ignore cache errors (quota, privacy mode, etc.)
  }
}

export default {
  namespaced: true,
  state: () => ({
    items: [],
    selectedGroupIds: [],
    showMine: true, // kept for UI; in Phase2 all visible already includes mine
    loading: false,
  }),
  getters: {
    events: (s) => s.items,
    selectedGroupIds: (s) => s.selectedGroupIds,
    showMine: (s) => s.showMine,
    loading: (s) => s.loading,
  },
  mutations: {
    setLoading(s, v) {
      s.loading = v;
    },
    setEvents(s, items) {
      s.items = items;
    },
    setSelectedGroupIds(s, ids) {
      s.selectedGroupIds = ids;
    },
    setShowMine(s, v) {
      s.showMine = v;
    },
  },
  actions: {
    async refresh({ commit, rootGetters, state }) {
      const uid = rootGetters["auth/uid"];
      if (!uid) return;

      // Hidratación rápida desde caché local para mejorar tiempo de primera pintura.
      if (!state.items.length) {
        const cachedItems = readCachedEvents(uid);
        if (cachedItems.length) {
          commit("setEvents", cachedItems);
        }
      }

      commit("setLoading", true);
      try {
        const items = await listVisibleEvents({
          uid,
          selectedGroupIds: state.selectedGroupIds,
        });
        commit("setEvents", items);
        writeCachedEvents(uid, items);
      } finally {
        commit("setLoading", false);
      }
    },
    async create({ rootGetters }, payload) {
      const uid = rootGetters["auth/uid"];
      return createEvent({
        uid,
        title: payload.title,
        description: payload.description,
        startAt: payload.startAt,
        endAt: payload.endAt,
        // ✅ nuevo
        shareByGroup: payload.shareByGroup,
        // compat (pueden ir, pero ya no mandan)
        groupIds: payload.groupIds,
        accessMode: payload.accessMode,
        allDay: payload.allDay,
      });
    },
    async update({ rootGetters }, payload) {
      const uid = rootGetters["auth/uid"];
      return updateEvent({
        uid,
        eventId: payload.eventId || payload.id,
        title: payload.title,
        description: payload.description,
        startAt: payload.startAt,
        endAt: payload.endAt,
        shareByGroup: payload.shareByGroup,
        groupIds: payload.groupIds,
        accessMode: payload.accessMode,
        allDay: payload.allDay,
      });
    },
  },
};
